import React from 'react';
import { Box } from '@styleseat/ui';
import {
  PortalOverlay,
  PortalOverlayHeader,
  PortalOverlayHeaderCloseBtn,
  PortalOverlayModal,
  HeaderText,
} from '../../ui';
import ShareMenuContainer, { ShareMenuContainerProps } from './ShareMenuContainer';

type ShareModalProps = {
  onCloseRequest: () => void;
} & ShareMenuContainerProps;

export const ShareModal: React.FCWithChildren<ShareModalProps> = ({
  onCloseRequest,
  ...props
}) => (
  <PortalOverlay name="share-modal">
    <PortalOverlayModal position="menu" boxProps={{ padding: 16 }}>
      <PortalOverlayHeader
        renderRightAction={() => (
          <PortalOverlayHeaderCloseBtn onCloseRequest={onCloseRequest} />
        )}
        renderTitle={() => (
          <Box justifyContent="center"><HeaderText level={2}>Share</HeaderText></Box>
        )}
      />
      <ShareMenuContainer
        {...props}
      />
    </PortalOverlayModal>
  </PortalOverlay>
);
